// ABOUTME: One crossing list row — originating label, coarse status, and an Open control (Issue #1939).
// ABOUTME: The Open control is hidden once the row reaches a terminal status (Complete/Expired).

import { Box, Button, Typography } from '@mui/material';
import type { CrossingListItemWithChild } from '../../hooks/useCrossings';
import { CrossingTrigger, CrossingStatus, BehaviorType } from '../../types/api';

const BEHAVIOR_LABEL: Partial<Record<BehaviorType, string>> = {
  [BehaviorType.Square]: 'Square',
  [BehaviorType.Reset]: 'Reset',
};

function originLabel(item: CrossingListItemWithChild): string {
  if (item.trigger === CrossingTrigger.ChildInitiated) return 'Reset';
  return BEHAVIOR_LABEL[item.triggerBehaviorType] ?? 'Square';
}

function statusLabel(status: CrossingStatus): string {
  switch (status) {
    case CrossingStatus.NotStarted: return 'Not started';
    case CrossingStatus.InProgress: return 'In progress';
    case CrossingStatus.Complete: return 'Completed';
    case CrossingStatus.Expired: return 'Expired';
    default: return '';
  }
}

interface CrossingListRowProps {
  item: CrossingListItemWithChild;
  onOpen: (crossingId: number) => void;
}

export default function CrossingListRow({ item, onOpen }: CrossingListRowProps) {
  const time = new Date(item.createdAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return (
    <Box component="li" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1, listStyle: 'none' }}>
      <Box>
        <Typography variant="body1">{originLabel(item)} · {time}</Typography>
        <Typography variant="body2" color="text.secondary">{statusLabel(item.status)}</Typography>
      </Box>
      {item.status !== CrossingStatus.Complete && item.status !== CrossingStatus.Expired && (
        <Button variant="outlined" onClick={() => onOpen(item.id)}>
          Open
        </Button>
      )}
    </Box>
  );
}
